import React from 'react'
import { hot } from 'react-hot-loader/root'
import { Container, Row, Col } from 'react-bootstrap'
import classNames from 'classnames'

import styles from './Home.scss'

const Home = (props) => <div className={styles.background}>
    <Container fluid={true} className="h-100">
        <Row noGutters={true} className="justify-content-center h-100">
            <Col className={styles.column} lg={{ span: 8 }}>
                <div>
                    <h1 className={classNames('mt-5', styles.mainHeading)}>Download page for the COMTAX SYSTEM&copy;</h1>
                    <p>Welcome to the download page for the COMTAX SYSTEM&copy;. Please follow the instructions below in order to download and install the COMTAX SYSTEM&copy;. If any problems occur please contact the <a href={`mailto:support@comtaxit.com`}>Support</a> and we will do our best to help you.</p>
                    <h2 className={classNames(styles.heading)}>Prerequisites</h2>
                    <p>Ensure that you have the following prerequisites installed and that they are up to date:</p>
                    <ul>
                        <li><a href="https://dotnet.microsoft.com/download/dotnet-framework">Microsoft .NET Framework 4.7.2 (or later)</a></li>
                    </ul>
                    <h2 className={classNames(styles.heading)}>Installation</h2>
                    <ol>
                        <li>If you have installed the COMTAX SYSTEM&copy; prior to August 2020 (clickonce-version) you need to first uninstall that by:
                    <ol>
                                <li>Start the Settings app in Windows</li>
                                <li>Navigate to Apps & Features</li>
                                <li>Locate the Comtax v.11 entry and click Uninstall.</li>
                            </ol>
                        </li>
                        <li>
                            Download the <a href="http://download-system.comtaxit.com/Prod/Releases/Setup.exe">Setup</a>
                        </li>
                        <li>
                            Run the setup
                </li>
                        <li>
                            If this is a first time install on a new system you will be prompted for the product key.
                </li>
                        <li>
                            Done! From this point on you will recieve updates automatically.
                </li>
                    </ol>
                    <p>Again if you are facing any issues please do not hesitate to contact our <a href={`mailto:support@comtaxit.com`}>Support</a>.</p>
                </div>
            </Col>
        </Row>
    </Container>
</div>

export default hot(Home);